/**
 * @generated SignedSource<<d9f0058396b2b02b63d21897b5287867>>
 * @relayHash 8bc48938bf783076b2da9973245c7133
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8bc48938bf783076b2da9973245c7133

import { ConcreteRequest } from 'relay-runtime';
export type Ch_deleteReferralLetterInput = {
  id: string;
};
export type useChDeleteReferralMutation$variables = {
  input: Ch_deleteReferralLetterInput;
};
export type useChDeleteReferralMutation$data = {
  readonly ch_deleteReferralLetter: {
    readonly ch_ReferralLetter: {
      readonly id: string;
    } | null;
  };
};
export type useChDeleteReferralMutation = {
  response: useChDeleteReferralMutation$data;
  variables: useChDeleteReferralMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChDeleteReferralMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_deleteReferralLetterPayload",
        "kind": "LinkedField",
        "name": "ch_deleteReferralLetter",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_ReferralLetter",
            "kind": "LinkedField",
            "name": "ch_ReferralLetter",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChDeleteReferralMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_deleteReferralLetterPayload",
        "kind": "LinkedField",
        "name": "ch_deleteReferralLetter",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_ReferralLetter",
            "kind": "LinkedField",
            "name": "ch_ReferralLetter",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "8bc48938bf783076b2da9973245c7133",
    "metadata": {},
    "name": "useChDeleteReferralMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "1b11de4ef65baa644f48bca912d2b150";

export default node;
